import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { GridApi } from 'ag-grid-community';
import {
    PutPositionMappingPayload,
    usePutPositionMapping,
} from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/hooks/hrPositionMapping';
import MappingFieldHeaderSelector from './MappingFieldHeaderSelector';
import { hrMappingFieldEnumAssociation } from '../helpers/constants';
import { StyMappingHeader } from 'routes/HumanResourcesModule/Settings/helpers/styles';

type Props = {
    selectedMappingsIds: number[];
    gridApi: GridApi;
};

export default function PositionMappingHeader({
    selectedMappingsIds,
    gridApi,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const updateMappingsMutation = usePutPositionMapping(true);

    return (
        <StyMappingHeader>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '5rem',
                    paddingTop: '1em',
                }}
            >
                <Box>
                    <Typography variant="body1">
                        {t(
                            'humanResources.settings.thereIsNPositionRecurrent',
                            {
                                count: selectedMappingsIds.length,
                            },
                        )}
                    </Typography>
                    <Typography variant="body1">
                        {selectedMappingsIds.length > 0
                            ? t('humanResources.settings.chooseAMappingValue')
                            : t('humanResources.settings.chooseMultiple')}
                    </Typography>
                </Box>
                {selectedMappingsIds.length > 0 && (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '3em',
                        }}
                    >
                        {Object.entries(hrMappingFieldEnumAssociation).map(
                            ([fieldToUpdate, fieldEnum]) => (
                                <MappingFieldHeaderSelector
                                    selectedMappingsIds={selectedMappingsIds}
                                    updateMappingsMutation={
                                        updateMappingsMutation
                                    }
                                    gridApi={gridApi}
                                    fieldToUpdate={
                                        fieldToUpdate as keyof PutPositionMappingPayload
                                    }
                                    fieldEnum={fieldEnum}
                                    key={fieldToUpdate}
                                />
                            ),
                        )}
                    </Box>
                )}
            </Box>
        </StyMappingHeader>
    );
}
